<template>

<div id="form-container" ref="formContainer">
    <div v-if="initialPageLoading">
        <div class="text-center">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
    </div>

    <div v-else>
      <b-button style="float:right;" type="button" variant="primary" @click="goBack">Back</b-button>
        <h1>HRM Request for {{ request.requestTypeValue.description }}</h1>


        <div class="card">
            <div class="card-header">Request Status</div>
            <div class="card-body">
                <b-row>
                    <b-col cols="3">
                        <p><strong>Tracking #</strong></p>
                        <h2>{{request.mdhTrackingId}}</h2>
                        <div v-if="request.jobId" style="font-size:.90em;">
                             {{ request.jobId }}
                        </div>
                        <div>{{ request.requestTypeValue.description }}</div>
                    </b-col>
                    <b-col cols="3">
                        <p>Status</p>
                        <h2>{{ request.requestStatusValue.description }}</h2>
                        <span></span>
                    </b-col>
                </b-row>
            </div>
        </div>
    <form-summary :validator="$v.request" ref="errorContainer" id="errorContainer"/>

    <PreonboardingLifecycle v-if="isPreonboardingLifecycle" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <ReferenceCheckLifecycle v-if="isReferenceCheckLifecycle" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>        

    <b-form>
        <b-row style="margin-bottom:18px;" v-if="isEditable">
            <b-col>
                <b-button type="button" variant="primary" v-if="!isEditing && isAssigned" @click="toggleEdit(false)">Edit Request</b-button>
                <b-button type="button" variant="primary" v-if="isEditing" @click="saveEdits">Update Request</b-button>
                <b-button type="button" variant="outline-primary" v-if="isEditing" @click="toggleEdit(true)">Cancel Editing</b-button>
            </b-col>
        </b-row>

    <div class="card" header-bg-variant="primary" header-text-variant="white">
        <div class="card-header">Attachments</div>
        <div class="card-body">
            <b-row>
                 <b-col cols="12" md="2" style="margin-bottom:8px;" v-if="isEditing">
                    <FileAttachment 
                        :id="this.request.id"
                        v-on:attachment-added="addAttachment"/>
                </b-col>
                <b-col>            
                    <b-table hover small show-empty
                        responsive="true"
                        :fields="attachmentFields"
                        :items="request.attachments"
                        :busy="false">      
                        <template v-slot:no-data>
                            No Attachments Found.
                        </template>
                        <template #table-caption></template>
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>  
                        <template v-slot:cell(actions)="row">
                            <b-button size="sm" :href="row.item.url" target="_attach" class="mr-1">
                                download
                            </b-button>
                            <b-button size="sm" variant="link" @click="removeAttachment(row.index, row.item)"
                                v-if="isEditing">
                                <b-icon icon="x-circle-fill" aria-hidden="true"></b-icon>
                            </b-button>
                        </template>
                        <template slot="empty" slot-scope="scope">
                            No Attachments Found.
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </div>
    </div>
  </b-form>
  </div>
</div>

</template>

<script>
import axios from "axios"
import _ from "lodash"
import {
  required,
  minLength,
  decimal,
  maxLength,
  numeric,
  requiredUnless,
  requiredIf,
  helpers,
  integer
} from 'vuelidate/lib/validators'
import { commonOptions } from '@/mixins/commonOptions.js'
import FileAttachment from '@/components/FileAttachment'

import minDate from "@/validators/minDate";
import PreonboardingLifecycle from '../components/lifecycles/PreonboardingLifecycle.vue'
import ReferenceCheckLifecycle from '../components/lifecycles/ReferenceCheckLifecycle.vue'
import {roleService} from "@/mixins/roleService";

const agcyValidator = (value) => !helpers.req(value) || (value >= 40000 && value <= 40002)
const terms = ['TBD', 'tbd']
const tbdValidator = (value) => !terms.some(el => value && value.indexOf(el) > -1)

export default {
    data() {
        return {
            keys: {
                location: 0,
                supervisor: 0,
                requestType: 0,
                leaveType: 0,
                denial: 0,
            },
            previousRequest: {},
            request: { },
            specialists: [],
            leaveTypeSubOptions: [],
            selectedSkills: [],
            reofferReasons: [],
            reofferReasonString: "",
            hasOtherRequiredSkill: false,
            initialPageLoading: true,
            isAssignedLifecycle: false,
            isRequesterReviewLifecycle: false,
            isPreonboardingLifecycle: false,
            isReferenceCheckLifecycle: false,
            isReviewPosting: false,
            isUnassigned: false,
            isAssigned: false,
            isPrimaryAssigned: false,
            isAuditLifecycle: false,
            isDraftPosting: false,
            isPosted: false,
            isReposted: false,
            isScreening: false,
            isManagerInterviewing: false,
            isSalaryReview: false,
            isPreOffer: false,
            isOffer: false,
            isMakeOffer: false,
            isBackgroundCheck: false,
            isComplete: false,
            isRDCSubmission: false,
            isRDCCandidate: false,
            isRDCOnboard: false,
            isEditing: false,
            isProcessing: false,
            transitionStatus: null,
            isReadyForCFOReview: false,
            isAssignPcn: false,
            isUpdatePcn: false,
            isCloseOut: false,
            isTransactionPPL: false,
            approvalStatusOptions: [
                { value: 'P', text: 'Pending' },
                { value: 'A', text: 'Approved' },    
                { value: 'R', text: 'Rejected' },    
            ],
            transitionLifeCycleOptions: [
                { value: '06', text: 'Start Audit' },
                { value: '07', text: 'Start Draft' },
                { value: '08', text: 'Posted'},
                { value: '09', text: 'Screen Applicants'},
            ],
            attachmentFields:  [
                {key: 'filename', sortable: true, label: 'File Name'},
                {key: 'type', sortable: true, label: 'File Type', formatter: 'getFileType'},
                {key: 'actions', label: 'Actions'}
            ],
            priorityOptions: [
              { value: '1', text: 'P1' },
              { value: '2', text: 'P2' },
              { value: '3', text: 'P3' },
              { value: '4', text: 'P4' },
              { value: '5', text: 'P5' },
               { value: '6', text: 'P6' },
                { value: '7', text: 'P7' },
                { value: '8', text: 'P8' },
                { value: '9', text: 'P9' },
                { value: '10', text: 'P10' },
                { value: '11', text: 'P11' },
                { value: '12', text: 'P12' },
                { value: '13', text: 'P13' },
                { value: '14', text: 'P14' },
                { value: '15', text: 'P15' },
                { value: '16', text: 'P16' },
                { value: '17', text: 'P17' },
                { value: '18', text: 'P18' },
                { value: '19', text: 'P19' },
                { value: '20', text: 'P20' },
                { value: '999', text: ' ' },
            ],
            options: {
                format: 'YYYY-MM-DD',
                useCurrent: false,
            },
            defaultRequestAttributes: {
                positionClassificationValue: {
                    code: '',
                    description: ''
                },
                appointmentValue: {
                    code: '',
                    description: ''
                },
                workScheduleValue: {
                    code: '',
                    description: ''
                },
                positionScheduleValue: {
                    code: '',
                    description: ''
                },
                workTravelValue: {
                    code: '',
                    description: ''
                },
                attachments: [],
                isLeaveRequestClosed: false
            },
            auditApprovedDate: null,
            salaryApprovedDate: null,
            salaryApprovedBy: null,
            payrollAction: null,

            payrollPPL: false,
            payrollFMLA: false,
            transactionPPL: false,
        }
    },
    mixins: [
       commonOptions,
       roleService,
    ],    
    
    components: {
        FileAttachment,
        PreonboardingLifecycle,
        ReferenceCheckLifecycle
    },

  validations() {
    return {
      transitionStatus: {},

      request: {
        positionNumber: {
          required: requiredIf(function () {
            return _.includes(['02', '03', '04', '05', '06', '07', '12'], this.request.requestTypeValue.code)
          }),
          maxLength: maxLength(8)
        },

        proposedClassification: {
          required: requiredIf(function () {
            return _.includes(['01', '02', '03', '04', '05', '06', '07', '08', '12'], this.request.requestTypeValue.code)
          })
        },

        previousIncumbent: {
          required: false,
          maxLength: maxLength(50)
        },

        classOption: {
          required: false,
          maxLength: maxLength(50)
        },

        workingTitle: {
          required: false,
          maxLength: maxLength(50)
        },

        positionLocation: {
          required: requiredIf(function () {
            return _.includes(['01', '02', '08', '09'], this.request.requestTypeValue.code)
          }),
          maxLength: maxLength(50),
        },

        hoursPerWeek: {
          required: requiredIf(function () {
            return _.includes(['01', '02', '08', '09'], this.request.requestTypeValue.code)
          }),
          numeric
        },

        workingHours: {
          required: requiredIf(function () {
            return _.includes(['01', '02', '08'], this.request.requestTypeValue.code)
          }),
          maxLength: maxLength(50)
        },

        division: {
          required: requiredIf(function () {
            return _.includes(['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '12'], this.request.requestTypeValue.code)
          }),
        },

        departmentId: {
          required: requiredIf(function () {
            return _.includes(['01', '02', '03', '04', '05', '06', '07', '08', '12'], this.request.requestTypeValue.code)
          }),
        },

        unitName: {
          required: false
        },


        supervisor: {
          userId: {
            required: requiredIf(function () {
              return _.includes(['01', '02', '03', '04', '05', '06', '07', '08', '10', '12'], this.request.requestTypeValue.code)
            }),
          }
        },

        employee: {
          userId: {
            required: requiredIf(function () {
              return _.includes(['10'], this.request.requestTypeValue.code)
            }),
          }
        },

        leaveType: {
          required: requiredIf(function () {
            return _.includes(['10'], this.request.requestTypeValue.code)
          })
        },

        workStatus: {
          required: requiredIf(function () {
            return _.includes(['10'], this.request.requestTypeValue.code)
          })
        },


        leaveDecision: {
          required: requiredIf(function () {
            return _.includes(['10'], this.request.requestTypeValue.code)
          })
        },

        denialReason: {
          required: requiredIf(function () {
            return this.request.leaveDecision === 'Denied'
          })
        },

        comments: {
          required: false,
          maxLength: maxLength(4000)
        },

        requestTypeValue: {
          code: {
            required: true
          }
        },

        positionClassificationValue: {
          code: {required: false}
        },

        positionScheduleValue: {
          code: {
            required: requiredIf(function () {
              return _.includes(['01', '02', '08', '09', '10'], this.request.requestTypeValue.code)
            })
          }
        },

        appointmentValue: {
          code: {
            required: requiredIf(function () {
              return _.includes(['01', '02', '03', '04', '05', '06', '08', '12'], this.request.requestTypeValue.code)
            })
          }
        },

        workScheduleValue: {
          code: {
            required: requiredIf(function () {
              return _.includes(['09'], this.request.requestTypeValue.code)
            })
          }
        },

        workTravelValue: {
          code: {
            required: requiredIf(function () {
              return _.includes(['01', '02', '08', '09'], this.request.requestTypeValue.code)
            })
          }
        },

        anticipatedStartDate: {
          required: requiredIf(function () {
            return _.includes(['01', '02', '08', '09', '10'], this.request.requestTypeValue.code)
          })
        },

        endDate: {
          required: requiredIf(function () {
            return _.includes(['07', '09', '10'], this.request.requestTypeValue.code)
          })
        },
        typeOfCovidLeave: {
          required: false,
          maxLength: maxLength(20)
        },
        workRestrictions: {
          required: false,
          maxLength: maxLength(15)
        },
        addlAuthNeeded: {
          required: false,
          maxLength: maxLength(15)
        },

        covidLeaveHrsUsed: {
          numeric,
          required: false
        },
        efmlaHrs: {
          required: false
        },
        leaveHours: {
          numeric,
          required: false
        },
        ptLeaveNeeds: {
          required: false,
          maxLength: maxLength(500)
        },

        selectedCandidateEmail: {maxLength: maxLength(75)},
        selectedCandidateName: {maxLength: maxLength(75)},
        selectedCandidateEmployeeId: {maxLength: maxLength(75)},
        selectedCandidateAddress: {maxLength: maxLength(75)},
        selectedCandidatePhone: {maxLength: maxLength(75)},
        flsaStatusValue: {},
        bargainingUnit: {},

        funding: {
          required: requiredUnless(function () {
            return _.includes(['10', '03', '06', '05'], this.request.requestTypeValue.code)
          }),
          minLength: minLength(1),
          $each: {
            fundingPercent: {
              required,
              numeric
            },
            fundId: {
              required,
              tbdValidator
            },
            divisionId: {
              required,
              tbdValidator
            },
            sourceType: {
                required: requiredIf(function(item) {
                    return item.project || item.activity
                }),
            },
            appropriationId: {
              required,
              tbdValidator
            },
            agcyCost1: {
              required: requiredIf(function (item) {
                if (item.divisionId) {
                  return item.divisionId.endsWith('3201')
                }
                return false
              }),
              agcyValidator,
              tbdValidator
            },
            project: {
                required: requiredIf(function(item) {
                    return ((item.fundId === '3000' || item.fundId === '3001') ||
                            (item.activity || item.sourceType))
                }),
                tbdValidator
            },
            activity: {
                required: requiredIf(function(item) {
                    return item.project || item.sourceType
                }),
                maxLength: maxLength(15),
                tbdValidator
            }
          }
        },

        coopLevel: {
          required: requiredIf(function () {
            return _.includes(['09'], this.request.requestTypeValue.code)
          })
        },

        dlRequired: {
          required: requiredIf(function () {
            return _.includes(['09'], this.request.requestTypeValue.code)
          })
        },

        teleworkAvailable: {
          required: false,
          maxLength: maxLength(1000)
        },

        softwareExpNeeded: {
          required: false,
          maxLength: maxLength(1000)
        },

        licCredsRequired: {
          required: requiredIf(function () {
            return _.includes(['09'], this.request.requestTypeValue.code)
          }),
          maxLength: maxLength(1000)
        },

        specificStaffRequested: {
          required: false,
          maxLength: maxLength(4000)
        },
        otherSkillSet: {
          required: false,
          maxLength: maxLength(100)
        },
        isLeaveRequestComplete: {required: false},
        isLeaveRequestClosed: {required: false},
        effectiveStartDate: {required: false},
        pcnUpdateComment: {required: false, maxLength: maxLength(1000)},
        step: {maxLength: maxLength(3)},
        rate: {decimal},
        probationaryPeriodLength: {maxLength: maxLength(20)},

        leaveRequestReceived: {required: false},
        certificationDeadline: {required: false},
        medCertReceived: {required: false},
        fmlaReason: {required: false},
        nbrCases: {required: false, integer},
        parenthoodLeaveConcurrent: {required: false},
        onProbation: {required: false},

        priority: {required: false},
        jobId: {maxLength: maxLength(10)},
        dd14ReceivedDate: {required: false},

        effectiveEndDate: {required: false, minDate: minDate(this.request.effectiveStartDate)},
        leaveComments: {required: false, maxLength: maxLength(4000)},
        delegate: { 
          userId: { required: false }
        }
      },
    }
  },

     computed: {
        _: function() {
            return _
        },
       
       showCancelButton: function() {
           return _.some(['01', '04', '06', '07', '08', '09', '10', '11', '12', '13', '14', '16'],
                        _.matches(this.request.requestStatusValue.code))
       },

       hasCFORole() {
           return this.isCfo()
       },

       hasLeaveRole() {
           return this.isLeave()
       },

       hasTransactionRole() {
           return this.isHRTransactions()
       },
       hasPayrollRole(){
         return this.isPayroll() || this.isAdmin()
       },

       isHiringManager() {
          let aSubmitter = this.request.submitter.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()
          let aSupervisor = this.request.supervisor.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()
          return _.some(['33'], _.matches(this.request.requestStatusValue.code)) && (aSubmitter || aSupervisor)
       },

       isEditable() {
           let result = true

           if (this.request.requestTypeValue.code === '09' && this.request.requestStatusValue.code === '01') {
               result = false
           }
           return result
       },
     },

    watch: {
        request: {
            deep: true,
            handler() {
                this.isUnassigned = this.request.requestStatusValue.code === '02' &&
                    !this.request.assigned.userId &&
                    !this.request.requestTypeValue.code === '09'

                this.isReadyForCFOReview = this.request.requestStatusValue.code === '02' && 
                    this.request.requestTypeValue.code === '09' &&
                    this.hasCFORole

                this.setAssigned()

                this.isPreonboardingLifecycle = this.request.requestStatusValue.code === '37'
                this.isReferenceCheckLifecycle = this.request.requestStatusValue.code === '36'
               
            }
        },
        transitionStatus() {
            this.transitionRequest()
        },
    },
    
    created() {
        this.requestId = this.$route.params.id

        this.fetchRequest()
        this.fetchLifecycles()
        this.fetchSpecialists()
    },

    methods: {
        setAssigned() {
          this.isAssigned = false
          this.isPrimaryAssigned = false
          //You can edit because you submitted this request
          if(this.request.requestStatusValue.code === '01'){
            this.isAssigned = this.request.submitter.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()
          }
          //You can edit because you are a leave specialist editing a leave request
          if(_.includes(['10'], this.request.requestTypeValue.code)){
            this.isAssigned = this.isAssigned || this.hasLeaveRole
          }
          //You can edit because you were assigned to this request
          if (this.request.assigned.userId && typeof this.request.assigned.userId === 'string' && this.request.completed === false) {
            this.isAssigned = this.isAssigned || this.request.assigned.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()
            this.isPrimaryAssigned = this.request.assigned.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()
          }
          //You can edit because you are a transactions specialist and this is in the transaction queue for close out
          if (this.request.requestStatusValue.code === '15' && this.request.completed && this.hasTransactionRole && this.request.transactionQueueStatus === 3) {
              this.isAssigned = true
          }
          //You can edit because you have been delegated permissions for this request
          
          if (this.isAssigned === false && this.request.delegate && this.request.delegate.userId && this.request.delegate.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()) {
            this.isAssigned = true
          }
        },
        
        forceLocationRerender(event) {
            //https://michaelnthiessen.com/force-re-render/
            this.keys.location += 1
        },
        forceSupervisorRerender(event) {
            //https://michaelnthiessen.com/force-re-render/
            this.keys.supervisor += 1
        },
        forceDenialRerender(event) {
            this.keys.denial += 1
        },
        forceLeaveTypeRerender(event) {
            this.keys.leaveType += 1
        },
        padPositionNumber() {
            this.request.positionNumber = String(this.request.positionNumber).padStart(8, '0')
        },
        fetchRequest() {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/${this.requestId}`)
                .then(response => {
                    this.initialPageLoading = false
                    this.request = _.merge(this.defaultRequestAttributes, response.data)
                    console.log(this.request)

                    //override the status for the two special statuses for hiring managers
                    if (this.$route.params.o && (this.$route.params.o == '36' || this.$route.params.o === '37')) {
                      this.request.requestStatusValue.code = this.$route.params.o

                      if (this.$route.params.o === '36') {
                        this.request.requestStatusValue.description = 'Reference Check'
                      }

                      if (this.$route.params.o === '37') {
                        this.request.requestStatusValue.description = 'Pre-Onboarding'
                      }
                    }
                    this.loadAttachmentTypes()
                })
        },
        fetchLifecycles() {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/lifecycle/${this.requestId}`)
              .then(response => {
                response.data.forEach(phase => {
                  if(phase.requestStatusCode === "06" && this.auditApprovedDate == null){
                    this.auditApprovedDate = phase.requestStatusOutDatetime
                  }
                  if(phase.requestStatusCode === "11" && this.salaryApprovedDate === null && phase.requestSubStatus !== 'N'){
                    this.salaryApprovedDate = phase.requestStatusOutDatetime
                    this.salaryApprovedBy = phase.userId
                  }
                  if((phase.requestStatusCode === '12' || phase.requestStatusCode === '13') && (phase.comments != null && phase.comments.startsWith("Reoffer Reason:"))){
                    this.reofferReasons.push(phase.comments)
                  }
                })
                this.reofferReasonString = this.reofferReasons.join(";\n");
              })
        },
       

        showToast(title, message, type) {
            this.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
        transitionRequest() {
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/transition`,
                    {
                        id: this.request.id,
                        transitionStatusTo: this.transitionStatus
                    })
                  .then(response => { 
                  this.request = response.data })
        },
        loadAttachmentTypes() {
            if (this.hasInternalAttachmentsRole()) {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachment/types/all`)
                    .then(response => {
                        this.attachmentTypes = response.data
                    })
            } else {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachment/types/ext`)
                    .then(response => {
                        this.attachmentTypes = response.data
                    })
            }

        },
        getFileType(value) {
            for (let i=0; i<this.attachmentTypes.length; i++) {
                if (this.attachmentTypes[i].code == value) {
                    return this.attachmentTypes[i].description
                }
            }
            return 'Unknown'
        },
        toggleEdit(needsReset) {
          if(this.isEditing && needsReset){
            //We are currently editing and we want to cancel
            this.$v.$reset();
            this.request = Object.assign({},this.previousRequest)
          }
          else{
            //we are going to make edits so we should have some previous stored up
            this.previousRequest = Object.assign({},this.request)
          }
         this.isEditing = !this.isEditing
        },
        addAttachment(value) {
            if (Array.isArray(this.request.attachments) && this.request.attachments.length) {
                this.request.attachments.push(value)
            } else {
                this.request.attachments = []
                this.request.attachments.push(value)
            }
        },
        removeAttachment(idx, item) {
            axios.delete(`${process.env.VUE_APP_API_BASE_URL}/attachment/${item.id}`)
                .then(response => {
                    this.request.attachments.splice(idx, 1)
                })                
        },
        saveEdits() {
            this.request.skillSet = this.selectedSkills.join("; ")
            if(this.getLeavePayrollActions() !== "") {
              this.request.payrollActionsString = this.getLeavePayrollActions()
            }else{
              delete this.request.payrollActionsString
            }
            if(this.transactionPPL){
              this.request.transactionQueueStatus = 5
            }
            else{
              delete this.request.transactionQueueStatus;
            }
            console.log(this.request)
             axios.put(`${process.env.VUE_APP_API_BASE_URL}/request`, this.request)
                  .then(response => {
                    this.showRootToast("Request Updated", "Your changes were applied.", "success")
                    if(this.transactionPPL){
                      this.showRootToast("Action Created", "Transaction action created.", "success")
                    }
                    if(this.getLeavePayrollActions() !== ""){
                      this.showRootToast("Action Created", "Payroll action(s) created.", "success")
                    }
                    this.fetchRequest()
                    this.toggleEdit(false)
                  })
        },
        goBack(){
          //This is not good enough, need a way to save the state of searching
          this.$router.back()
        },

        close() {
            this.$bvModal.hide('pcnUpdateModal')
        },

        savePcnRequest() {
            let payload = {
                requestId: this.request.id,
                requestText: this.request.pcnUpdateComment
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/transactions/pcnupdate`, payload)
                .then(response => { 
                    this.$bvToast.toast('PCN Update Request Submitted', {
                        title: 'Status',
                        toaster: 'b-toaster-top-center',
                        solid: true,
                        variant: 'success',
                        appendToast: true
                    }) 
                });          
            this.close()
        },

        translate(code) {
            var result = 'not provided'
            this.flsaStatusOptions.forEach((item) => {
                if (item.value === code) {
                    result = item.text
                }
            })
            return result
        },

        translateBU(code) {
            var result = 'not provided'
            this.bargainingUnitOptions.forEach((item) => {
                if (item.value === code) {
                    result = item.text
                }
            })
            return result
        },
        
        changeLeaveTypeOptionsAndClear() {
            this.changeLeaveTypeOptions()
            this.request.typeOfCovidLeave = null
        },

        changeLeaveTypeOptions() {
            this.leaveTypeSubOptions = []

            if (this.request.leaveType === 'COVID/EFMLA') {
                this.leaveTypeSubOptions = this.covidLeaveTypeOptions      
            } 
            if (this.request.leaveType === 'FMLA') {
                this.leaveTypeSubOptions = this.fmlaLeaveTypeOptions
            }
            if (this.request.leaveType === 'Contractual') {
                this.leaveTypeSubOptions = this.contractLeaveTypeOptions
            }
        },
        getPayrollActionCodes(payrollAction) {
          if(payrollAction === 'REV'){
              return {code: 38, description: 'Closeout Payroll Review'}
          }
          if(payrollAction === 'PPL'){
            return {code: 30, description: 'PPL Leave - Payroll'}
          }
          if(payrollAction === 'FMLA'){
            return {code: 31, description: 'FMLA Leave - Payroll'}
          }
          return null
        },
      getLeavePayrollActions() {
          let actions = [];
          if(this.payrollPPL){
            actions.push('PPL')
          }
          if(this.payrollFMLA){
            actions.push('FMLA')
          }
        return actions.join(',');
      },

      fetchSpecialists() {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/organization/delegate`)
                .then(response => {
                   this.specialists = []

                    console.log(response.data)

                    response.data.forEach((person) => {
                        let option = {
                            value: person.userId,
                            text: person.name
                        }
                        this.specialists.push(option)
                    }) 
                    console.log(this.specialists)  
                });
      },
    }
}
</script>

<style>
.card {
    margin-bottom: 18px;
}
.card-header {
    font-weight: 700;
}
</style>